interface Props {
  fillColor: string;
  className?: string;
}

export const CaretDownIcon = ({ fillColor, className }: Props) => (
  <svg className={className} fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.66667"
    />
  </svg>
);
